import React from 'react';
import moment from 'moment';
import { Table, Thead, Tr, Th, Td, Tbody, Button, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton } from '@chakra-ui/react';
import '../elements/DocumentStep.css'

interface DocumentStepProps {
    step: any | null;
    allowed: any | null;
    currentStep: any | null;
    selectedStep: any | null;
    filled: any | null;
    editDocument: (stepNumber:any) => void;
    setSelectedStep: (step:any) => void;
}

const DocumentStep: React.FC<DocumentStepProps> = ({ step, allowed, currentStep, selectedStep, filled, editDocument, setSelectedStep }) => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Tr key={step.stepNumber} className={`document-step ${allowed ? "" : "not-allowed-step"}`}>
            <Td>
                <strong className="strong">{currentStep.stepName}</strong><br />
                <small>{currentStep.stepDescription}</small>
            </Td>
            <Td>
                {allowed ? null : <strong>You don't have permission to fill out this step</strong>}
                {filled ? (
                    <div>
                        Filled out by {step.stepHistory[step.stepHistory.length - 1].userAlias}{" "}
                        {moment(step.stepHistory[step.stepHistory.length - 1].timestamp).local().fromNow()}
                    </div>
                ) : (
                    <div>{allowed ? "Not yet filled out" : null}</div>
                )}
            </Td>
            <Td style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button className="el-btn" colorScheme="#333" style={{ cursor: allowed ? "pointer" : "initial" }} onClick={allowed ? () => editDocument(step.stepNumber) : undefined} isDisabled={!allowed}>
                    {filled ? 'Edit Step' : 'Fill out Step'}
                </Button>

                {filled && allowed && (
                    <>
                        <Button className="el-btn" colorScheme="#333" style={{ cursor: "pointer", marginLeft: "10px" }} onClick={() => { setSelectedStep(step); onOpen(); }}>
                            History
                        </Button>

                        <Modal isOpen={isOpen} size="full" onClose={onClose} isCentered>
                            <ModalOverlay bg='none' backdropFilter='auto' backdropBlur='10px' />
                            <ModalContent className="modal" borderRadius="0px" boxShadow="xl" maxWidth="800px">
                                <ModalHeader>{currentStep?.stepName} history</ModalHeader>
                                <ModalCloseButton className="modal-close-button"/>
                                <ModalBody className="modal-body">
                                <Table variant="simple" size="sm">
                                        <Thead>
                                            <Tr>
                                                <Th>Updated by</Th>
                                                <Th>At</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody className="table" >
                                            {selectedStep?.stepHistory?.map((history:any, idx:number) => (
                                                <Tr key={idx}>
                                                    <Td>{history.userAlias} <small>({history.userName})</small></Td>
                                                    <Td>{moment(history.timestamp).format('MMMM Do YYYY, h:mm A')} <small>({moment(history.timestamp).local().fromNow()})</small></Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>

                                    {selectedStep?.stepHistory?.length === 0 && (
                                        <p className="no-data-message">No data available</p>
                                    )}
                                </ModalBody>
                            </ModalContent>
                        </Modal>
                    </>
                )}
            </Td>
        </Tr>
    );
};

export default DocumentStep;